import { createFileRoute } from '@tanstack/react-router'
import { SettingsHub } from '../../../features/settings/hub'

/** The settings hub: the rail of sections and the open section (each section guards itself). */
export const Route = createFileRoute('/_app/settings')({
  staticData: { crumb: 'settings' },
  component: SettingsHub,
})
